import { render, staticRenderFns } from "./BlackOverlay.vue?vue&type=template&id=8126448a&scoped=true"
import script from "./BlackOverlay.vue?vue&type=script&lang=js"
export * from "./BlackOverlay.vue?vue&type=script&lang=js"
import style0 from "./BlackOverlay.vue?vue&type=style&index=0&id=8126448a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8126448a",
  null
  
)

export default component.exports